import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SnotifyService } from 'ng-snotify';
import { DragulaService } from 'ng2-dragula';
import { RestDataService } from '../../../service/rest-data.service';
import { SharedDataService } from '../../../service/shared-data.service';
import { cloneDeep } from 'lodash';
//import * as ClassicEditor from '@harshit25/ckeditor5-build-blankpaper';
import * as ClassicEditor from "../../../../assets/js/ckeditor"
import { ElementModuleComponent } from '../../element-module/element-module.component';
import { StaticDataService } from '../../../service/static-data.service';
import { Config } from '../../../config/config';

@Component({
  selector: 'app-page-inline',
  templateUrl: './page-inline.component.html',
  styleUrls: ['./page-inline.component.scss']
})
export class PageInlineComponent implements OnInit, OnDestroy {

  storyEditMode = true;
  tempCardData = null;
  showTempPara = false;
  Elements = {};
  //viewPortItems = [];
  tempParaData = null;
  tempParaId = null;
  storySentenceCount = 0;
  storySyllableCount = 0;
  storyWordCount = 0;
  elementChangeData: any = {};
  lastFocusedCard = null;
  focusedCard = null;

  inlineImageToggle = false;
  inlineTableToggle = false;
  showLoader = false;
  tempElementList: any = [];
  inlineImageFlag = false;
  cropAllGallery = false;
  imageCroppingQue: any[] = [];
  hideElementId = null;
  embedPopup = false;
  embedCode = '';
  separator = '';
  label = '';
  embedSourceUrl = '';
  embedSubType = '';
  showLShapeBand = false;
  isLightboxVideo = false;
  isVideopopup = false;
  leadMediaVideoToggle = false;
  elementDestination = null;
  enableJW = 'false';
  showJW = false;
  showYT = true;
  enableYT = 'true';
  videoLeadImage = '';
  videoUrl = '';
  paraBeforeVideo = false;
  tableEditor = null;
  tableReusablePopup = false;
  tablePopup = false;
  tableHTML = '';
  public ckEditorTable = ClassicEditor;
  public ckEditorFAQ = ClassicEditor;
  showFaqPopup = false;
  tempFaqData: FormGroup;
  faqs: FormArray;
  domainConfig = {};
  croppingInProgress = false;
  showCropper = false;
  selectedFile: File = null;

  @ViewChildren('elReferenc') elReference: QueryList<any>;
  @ViewChildren('newElement') elRef: ElementModuleComponent;
  @Input()
  pageData: any;

  @Input()
  lastindex: any

  @Input()
  changeFlag: boolean

  @Input()
  viewPortItems: any[];

  @Output() generateAutoSave = new EventEmitter<any>();
  @Output() destroyAutoSave = new EventEmitter<any>();


  tableConfig = {
    toolbar: ['bold', 'italic', 'underline', 'numberedList', 'bulletedList', 'link', '|', 'insertTable'],
    table: {
      contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
    }
  };

  faqConfig = {
    toolbar: ['numberedList', 'bulletedList', 'link'],
    link: {
      decorators: {
        isExternal: {
          mode: 'automatic',
          callback: url => url,
          attributes: {
            target: '_blank'
          }
        }
      }
    }
  };

  showListiclePopup = false;
  tempListicleData: FormGroup;
  listicleArray: FormArray;
  videoIndex:any;
  enableListicleImageOption: boolean;
  listicleMediaVideo:any;
  showEmbedForListcleElement = false;
  listicleEmbedCode: any;
  @ViewChild('embedEl', {static: false}) embedElement: ElementRef;
  SingleselectedFile: File = null;
  imageUploadInProgress = false;
  imageLoaded: boolean = true;
  cropperImageUrl = {
    url: null,
    data: null,
    blobData: null
  };
  thumborCompressed: boolean;
  uploadType: any;
  showDefaultImageSelector: boolean = false;
  imageLoaderShow = false;
  listicleInlineImageFlag = false;
  addedParaAtLast = false;
  enableUrlInListicle = false;
  relatedStoryType:string='';
  storyList:any;
  relatedStoryMultipleSelectFlag: boolean;
  showAlsoReadStoryPopup: boolean;
  showLabelPopup= false;
  showSeparatorPopup=false;

  constructor(private snotify: SnotifyService,
    private http: HttpClient,
    private sharedService: SharedDataService,
    private restService: RestDataService,
    private dragulaService: DragulaService,
    private formBuilder: FormBuilder,
    private config: Config) {
    this.snotify.clear();
    this.sharedService.getCurrentDomainConfig(this.getDomainConfig.bind(this));
    this.enableUrlInListicle = this.sharedService.isdomainConfig('story','enableUrlInListicle');
    this.enableJW = this.domainConfig['config']['story']['enableJW'] ? this.domainConfig['config']['story']['enableJW'] : 'true';
    this.enableYT = this.domainConfig['config']['video']['isYouTube'] ? this.domainConfig['config']['video']['isYouTube'] : false;
    if (this.enableJW === 'true') {
      this.showJW = true;
      this.showYT = false;
    }
    else if (this.enableYT) {
      this.showJW = false;
      this.showYT = true;
    }
    dragulaService.setOptions('element-bag', {
      moves: function (el, container, handle) {
        return (handle.className === 'handle sortpara' || handle.className === 'icon-move');
      }
    });
    dragulaService.dropModel.subscribe((value) => {
      console.log(this.pageData);
      console.log(this.viewPortItems);
      this.pageData.bodyElements = cloneDeep(this.viewPortItems);
    });
  }

  ngOnInit() {
    setTimeout(e => {
      this.checkIfLastIsPara(false);
    }, 1500);
  }

  ngOnDestroy() {
    if (this.dragulaService.find('element-bag')) {
      this.dragulaService.destroy('element-bag');
    }
  }

  getDomainConfig(currentDomainConfig) {
    // console.log(currentDomainConfig);
    this.domainConfig = currentDomainConfig;
  }


  lastParaIndex(ev) {
    this.lastindex = ev;
  }

  currentCardId(ev) {
    this.lastFocusedCard = this.focusedCard ? this.focusedCard : ev;
    this.focusedCard = ev;
  }

  childKeyDownEventCatcher(ev) {
    //this.childKeyDownEvent = ev;
  }

  getWordCount(ev) {
    this.runWordCountCheck();
  }

  runWordCountCheck() {
    if (this.pageData && this.pageData !== null && this.pageData.bodyElements &&
      (this.pageData.bodyElements.length <= Object.keys(this.Elements).length)) {
      this.storyWordCount = 0;
      this.storySentenceCount = 0;
      this.storySyllableCount = 0;
      for (const id of this.pageData.bodyElements) {
        const data = this.Elements[id];
        if (data && data !== null) {
          this.storyWordCount += data.metadata.wordCount;
          this.storySentenceCount += data.metadata.sentenceCount;
          this.storySyllableCount += data.metadata.syllableCount;
        }
      }
    }
  }

  deleteCardEmit(ev) {
    console.log('called delete function')
    const ind = this.viewPortItems.indexOf(ev);
    if (this.pageData.bodyElements.indexOf(ev) > -1) {
      if (ind > -1) {
        this.viewPortItems.splice(ind, 1);
      }
      this.pageData.bodyElements.splice(this.pageData.bodyElements.indexOf(ev), 1);
      //this.runWordCountCheck();
      this.changeFlag = true;
    }
    setTimeout(e => {
      this.checkIfLastIsPara(false);
    }, 50);

    // if (this.elementDataArray && this.elementDataArray.length > 0) {
    //   this.elementDataArray = this.elementDataArray.filter(data => data.id !== ev);
    // }
  }

  checkIfLastIsPara(focus) {
    if(!this.addedParaAtLast) {
    const len = (this.pageData.bodyElements) ? this.pageData.bodyElements.length : 0;
    if (len > 0) {
      const dataForElement = this.Elements[this.pageData.bodyElements[len - 1]];
      if (!this.hideElementId) {
        if (dataForElement && dataForElement !== null && dataForElement['type'] !== 'paragraph') {
          this.resetLastPara(focus);
        } else {
          this.hideElementId = null;
          this.showTempPara = false;
          this.tempParaData = null;
          this.tempParaId = null;
          this.tempParaData = JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
          this.tempParaData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
        }
      } else {
        if (this.pageData.bodyElements[len - 1] !== this.hideElementId) {
          this.showTempPara = false;
          this.hideElementId = null;
          this.tempParaData = null;
          this.tempParaId = null;
          this.tempParaData = JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
          this.tempParaData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
        }
      }
    } else {
      this.resetLastPara(focus);
    }
    }
  }

  addParaAtLast()
  {
    if(this.showTempPara) {
      this.snotify.info('Temp Para is already present at last.','', this.sharedService.getConfig(false));
    } else {
      this.addedParaAtLast = true;
      this.resetLastPara(false)
    }
  }

  deleteTempParaEmit(event)
  {
    this.addedParaAtLast = false;
    this.lastFocusedCard = null;
    this.lastindex = null;
    this.focusedCard = null;
    setTimeout(e => {
      this.checkIfLastIsPara(false);
    }, 50);
  }

  resetLastPara(focus) {
    this.showTempPara = false;
    this.hideElementId = null;
    this.tempParaData = null;
    this.tempParaId = null;
    this.tempParaData = JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
    this.tempParaData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    setTimeout(e => {
      this.showTempPara = true;
      if (focus) {
        if (this.elRef !== null && this.elRef['last'] !== null) {
          setTimeout(e2 => {
            this.elRef['last'].setFocusOnThis('start');
          }, 150);
        }
      }
    }, 50);
  }

  getUpadtedElementContent(ev) {
    if (ev && ev.id && ev.id !== null) {
      this.Elements[ev.id] = ev;
    }
  }

  getTempParaSavedId(ev) {
    this.hideElementId = ev.id;
    this.tempParaData = ev;
    this.tempParaId = ev.id;
    if (ev.id) {
      if (this.pageData.bodyElements && this.pageData.bodyElements !== null && this.pageData.bodyElements.length > 0) {
        const id = this.pageData.bodyElements[this.pageData.bodyElements.length - 1];
        const ind = this.viewPortItems.indexOf(id);
        if (ind > -1) {
          this.viewPortItems.splice(ind + 1, 0, ev.id);
        }
        this.pageData.bodyElements.push(ev.id);
      } else {
        this.viewPortItems.push(ev.id);
        this.pageData.bodyElements = [];
        this.pageData.bodyElements.push(ev.id);
      }

    }
  }

  showElementOfTempPara(ev) {
    if ((this.showTempPara) && (this.hideElementId === ev.cardId) && (ev.id === 'newElement')) {
      this.showTempPara = false;
      this.addedParaAtLast = false;
      this.hideElementId = null;
      this.tempParaData = null;
      this.tempParaId = null;
      this.tempParaData = JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
      this.tempParaData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
      setTimeout(e => {
        this.checkIfLastIsPara(false);
      }, 70);
    }
  }

  serveElementContent(id) {
    if (id && id !== null && this.elementChangeData.hasOwnProperty(id) && this.elementChangeData[id] !== null) {
      return this.elementChangeData[id];
    } else {
      return null;
    }
  }

  removeSaved(ev) {
    delete this.elementChangeData[ev];
  }

  getCardDatafromElement(ev) {
    if (ev.id) {
      this.elementChangeData[ev['id']] = ev;
    }
  }


  openInlineImageOption(type) {
    if (type === 'image') {
      this.inlineImageToggle = !this.inlineImageToggle;
      this.inlineTableToggle = false;
    } else if (type === 'table') {
      this.inlineTableToggle = !this.inlineTableToggle;
      this.inlineImageToggle = false;
    }
  }

  onInlineFileChange(event, model) {
    // console.log('file uplaod called');
    let file_name = <File>event.target.files[0].name;
    // let eventCategory='Insert Pdf';
    // let eventAction=sessionStorage.getItem(StaticDataService.tenantName);
    // let eventLabel='';
    // let eventValue=null;
    const fd = new FormData();
    this.selectedFile = <File>event.target.files[0];
    // console.log(event.target.files[0] instanceof File);
    // console.log(this.selectedFile);
    if (!this.checkSpecialChars(file_name)) {
      this.showLoader = true;
      if (event.target.files && event.target.files.length > 0) {
        if ((this.selectedFile.size / 1000000) <= 11) {
          fd.append('file', this.selectedFile, this.selectedFile.name);
          //this.increasePendingCount();
          this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadEndPoint, fd).
            subscribe(res => {
              //this.decreasePendingCount(null);
              this.saveCardByPath(res['images'].original, model, null, null);
              this.showLoader = false;
              event.target.value = null;
            },
              err => {
                //this.decreasePendingCount(null);
                this.showLoader = false;
                event.target.value = null;
              });
        } else {
          this.showLoader = false;
          event.target.value = null;
          this.selectedFile = null;
          this.snotify.error('Image size exceeds 12 MB', '', this.sharedService.getConfig(false));
        }
      }
    } else {
      console.log("not true")
    }

    // this.isLightbox = false;
    // this.leadMediaImageToggle = false;
    // this.leadMediaHomeImageToggle = false;
    this.inlineImageToggle = false;
  }

  checkSpecialChars(imageFileName) {
    let regex = new RegExp(/[^a-zA-z0-9-_.\s]+/g);
    let m;
    m = regex.exec(imageFileName);
    if (m) {
      imageFileName = imageFileName.replace(regex, '');
      console.log("rejected => ", imageFileName)
      this.snotify.error('Special Chars not Allowed in uploaded image', '', this.sharedService.getConfig(false));
      return true;
    }
    if (imageFileName.length > 50) {
      this.snotify.error('File Name should be less than 50 Charecters', '', this.sharedService.getConfig(false));
      imageFileName = imageFileName.slice(0, 50);
      return true;
    }
    return false;
  }

  saveCardByPath(imagePath, model, i, length, callback?, elementPosition?) {
    console.log("inside saveCardByPath method", model);
    const defaultImagecardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
    defaultImagecardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    if (defaultImagecardData) {
      defaultImagecardData.id = null;
      defaultImagecardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
      defaultImagecardData.image.images = {};
      defaultImagecardData.image.images['original'] = imagePath.replace(/"/gi, '');
      // this.increasePendingCount();
      console.log('hitting api for element creation')
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
        defaultImagecardData, result => {
          console.log("inside saveCardByPath save element call response");
          //this.decreasePendingCount(null);
          if (model === 'elements') {
            console.log('inside saveCardByPath method for elements');
            const arr = [];
            arr.push(result);
            // if (i != null && length != null && i == (length - 1)) {
            //   this.generateStoryAutoSaveInterval();
            // }
            console.log('going inside decideTaskToPerformNew')
            this.decideTaskToPerformNew(arr, 0, e => {
              setTimeout(() => {
                this.checkIfLastIsPara(false);
              }, 100);
            }, elementPosition);
          }
        });
    }
    return null;
  }


  decideTaskToPerformNew(dataArr, focus, callback, elementPosition?) {
    // debugger;
    // console.log('inside decideTaskToPerformNew :: dataArr' , dataArr);
    console.log('decideTaskToPerformNew', '0---', dataArr, '1==>', this.focusedCard, '2==>', focus, '3===>', this.lastindex);
    if (this.focusedCard === 'newElement' && this.lastindex && this.lastindex.id === 'newElement'
      && this.lastindex.cardID && this.lastindex.cardID !== null) {
      this.showElementOfTempPara({
        id: this.lastindex.id,
        cardId: this.lastindex.cardID
      });
    }

    let viewPortindex = (this.focusedCard && this.focusedCard !== 'newElement')
      ? this.viewPortItems.indexOf(this.focusedCard)
      : (
        (this.focusedCard === 'newElement' && this.lastindex && this.lastindex.id === 'newElement' && this.lastindex.cardID)
          ? this.viewPortItems.indexOf(this.lastindex.cardID)
          : -1
      );
    setTimeout(e4 => {
      let index = (this.pageData && this.pageData.bodyElements) ?
        (
          (this.focusedCard && this.focusedCard !== 'newElement')
            ? this.pageData.bodyElements.indexOf(this.focusedCard) :
            (
              (this.focusedCard === 'newElement' && this.lastindex && this.lastindex.id === 'newElement' && this.lastindex.cardID)
                ? this.pageData.bodyElements.indexOf(this.lastindex.cardID)
                : 0
            )
        )
        : 0;
      // console.log(viewPortindex, index, this.focusedCard);
      if (this.focusedCard !== null && viewPortindex > -1) {
        if (this.elReference['_results'] && this.elReference['_results'].length > 0) {
          const currentEle = (this.focusedCard && this.focusedCard !== 'newElement')
            ? (this.elReference['_results'].filter(item => {
              return item.cardId === this.focusedCard;
            }))
            : (
              (this.focusedCard === 'newElement' && this.lastindex && this.lastindex.id === 'newElement' && this.lastindex.cardID)
                ? (this.elReference['_results'].filter(item => {
                  return item.cardId === this.lastindex.cardID;
                }))
                : []
            );
          // console.log(currentEle);
          if (currentEle[0] && currentEle[0]['cardType'] !== 'paragraph') {
            for (let i = 0; i < dataArr.length; i++) {
              const element = dataArr[i];
              viewPortindex = viewPortindex + 1;
              index = index + 1;
              if (!this.pageData.bodyElements.includes(element.id)) {
                this.viewPortItems.splice(viewPortindex, 0, element.id);
                this.pageData.bodyElements.splice(index, 0, element.id);
                setTimeout(e => {
                  const dataIndexInViewPort = this.viewPortItems.indexOf(element.id);
                  if (dataIndexInViewPort > -1) {
                    this.elReference['_results'][dataIndexInViewPort].focusElementFromStory('start');
                  }
                }, 200);
              }
            }
            callback(null);
          } else if (currentEle[0]) {
            const paraIndex = this.lastindex['index'];
            currentEle[0].destroyCardAutoSaveInterval();
            currentEle[0].checkSplitFeasibility(paraIndex, this.lastindex['id'], (evn, arr) => {
              // console.log('evn :: ', evn);
              // console.log('arr :: ', arr);
              if (evn === 'top') {
                currentEle[0].generateCardAutoSaveInterval();
                for (let i = 0; i < dataArr.length; i++) {
                  const element = dataArr[i];
                  if (!this.pageData.bodyElements.includes(element.id)) {
                    this.viewPortItems.splice(viewPortindex, 0, element.id);
                    this.pageData.bodyElements.splice(index, 0, element.id);
                    viewPortindex = viewPortindex + 1;
                    index = index + 1;
                    setTimeout(e => {
                      const dataIndexInViewPort = this.viewPortItems.indexOf(element.id);
                      if (dataIndexInViewPort > -1) {
                        this.elReference['_results'][dataIndexInViewPort].focusElementFromStory('start');
                      }
                    }, 200);
                  }
                }
                callback(null);
              } else if (evn === 'bottom') {
                console.log("HERE BOTTOM")
                currentEle[0].generateCardAutoSaveInterval();
                for (let i = 0; i < dataArr.length; i++) {
                  const element = dataArr[i];
                  viewPortindex = viewPortindex + 1;
                  index = index + 1;
                  console.log(element.id)
                  if (!this.pageData.bodyElements.includes(element.id)) {
                    this.viewPortItems.splice(viewPortindex, 0, element.id);
                    this.pageData.bodyElements.splice(index, 0, element.id);
                    setTimeout(e => {
                      const dataIndexInViewPort = this.viewPortItems.indexOf(element.id);
                      if (dataIndexInViewPort > -1) {
                        this.elReference['_results'][dataIndexInViewPort].focusElementFromStory('start');
                      }
                    }, 700);
                  }
                }
                callback(null);
              } else if (evn === 'mid') {
                if (arr[0] == null || arr[0] === undefined || arr[0] == '' || arr[1] == null || arr[1] === undefined || arr[1] == '') {
                  this.snotify.error('error in para splitting, try again', '', this.sharedService.getConfig(false));
                } else {
                  // alert("csall")
                  currentEle[0].splitParaByIndex(paraIndex, arr, t => {
                    const paraElement = JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
                    paraElement.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
                    paraElement['id'] = null;
                    // console.log('t ::: ', t);
                    paraElement['paragraph']['body'] = t;
                    //this.increasePendingCount();
                    this.restService.http_post(this.config.get('product').baseUrl
                      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
                      paraElement, result2 => {
                        // console.log('result2 :: ', result2);
                        //this.decreasePendingCount(null);
                        // alert(this.isCKEditorEnabled)

                        currentEle[0].setParagraphData(this.confirmParaBreak(arr[1]));

                        currentEle[0].generateCardAutoSaveInterval();
                        currentEle[0].doCheck();
                        if (!this.pageData.bodyElements.includes(result2.id)) {
                          this.viewPortItems.splice(viewPortindex, 0, result2.id);
                          this.pageData.bodyElements.splice(index, 0, result2.id);
                          let viewIdIndex = this.viewPortItems.indexOf(result2.id);
                          let idIndex = this.pageData.bodyElements.indexOf(result2.id);
                          for (let i = 0; i < dataArr.length; i++) {
                            const element = dataArr[i];
                            viewIdIndex = viewIdIndex + 1;
                            idIndex = idIndex + 1;
                            if (!this.pageData.bodyElements.includes(element.id)) {
                              this.viewPortItems.splice(viewIdIndex, 0, element.id);
                              this.pageData.bodyElements.splice(idIndex, 0, element.id);
                              setTimeout(e => {
                                const dataIndexInViewPort = this.viewPortItems.indexOf(element.id);
                                if (dataIndexInViewPort > -1) {
                                  this.elReference['_results'][dataIndexInViewPort].focusElementFromStory('start');
                                }
                              }, 200);
                            }
                          }
                          callback(null);
                        }
                      });
                  });
                }
              } else {
                currentEle[0].generateCardAutoSaveInterval();
              }
            });
          }
        }
      } else {
        if (dataArr && dataArr.length > 0) {
          for (let i = 0; i < dataArr.length; i++) {
            const element = dataArr[i];

            if (elementPosition && elementPosition === 'top') {
              this.viewPortItems.unshift(element.id);
              this.pageData.bodyElements.unshift(element.id);
            }
            else {
              this.viewPortItems.push(element.id);
              if (this.pageData.bodyElements == null || this.pageData.bodyElements == undefined) {
                this.pageData.bodyElements = [];
                this.pageData.bodyElements.push(element.id);
              } else {
                this.pageData.bodyElements.push(element.id);
              }
            }
            console.log('this.storyData.elements', this.pageData.bodyElements)
            setTimeout(e => {
              const dataIndexInViewPort = this.viewPortItems.indexOf(element.id);
              if (dataIndexInViewPort > -1 && this.elReference && this.elReference['_results']
                && this.elReference['_results'][dataIndexInViewPort]) {
                this.elReference['_results'][dataIndexInViewPort].focusElementFromStory('start');
              }
            }, 100);
            callback(null);
          }
        }
        if (focus) {
          setTimeout(e => {
            for (let i = 0; i < dataArr.length; i++) {
              const dataIndexInViewPort = this.viewPortItems.indexOf(dataArr[i].id);
              if (dataIndexInViewPort > -1 && this.elReference && this.elReference['_results']
                && this.elReference['_results'][dataIndexInViewPort]) {
                this.elReference['_results'][dataIndexInViewPort].focusElementFromStory('start');
              }
            }
            callback(null);
          }, 100);
        }
      }
    }, 100);
  }

  confirmParaBreak(paraStr: String) {
    if (paraStr.indexOf('|#+|') !== -1) {
      return paraStr.split('|#+|')[1].trim();
    } else {
      return paraStr;
    }
  }

  multipleInlineUpload(event, model) {

    const Files = event.target.files;
    const length = Files['length'];
    this.tempElementList = [];
    this.showLoader = true;
    let tempId;
    if (event.target.files && (event.target.files.length > 0)) {

      //this.destroyStoryAutoSaveInterval();
      let hasAnImage = false;
      for (let i = 0; i < length; i++) {
        let file_name = <File>event.target.files[i].name;
        console.log(file_name)
        const image = <File>Files[i];
        if (!this.checkSpecialChars(file_name)) {
          if ((image.size / 1000000) <= 11) {
            hasAnImage = true;
            //this.destroyPageAutoSaveInterval();
            this.destroyAutoSave.emit();
            const fd = new FormData();
            fd.append('file', image, image.name);
            //this.increasePendingCount();
            this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadEndPoint, fd).
              subscribe(res => {
                //this.decreasePendingCount(null);
                this.saveCardByPath(res['images'].original, 'tempElements', null, null, (id) => {
                  if (i === 0) {
                    this.createDuplicateImageChild(id, fn => {
                      if (fn !== false) {
                        const arr = [];
                        arr.push(fn);
                        tempId = fn.id;
                        this.decideTaskToPerformNew(arr, 0, e => {
                          setTimeout(() => {
                            this.checkIfLastIsPara(false);
                          }, 250);
                        });
                      }
                    });
                  } else {
                    this.tempElementList.push(id)
                  }
                });
              },
                err => {
                  //this.decreasePendingCount(null);
                  this.showLoader = false;
                });
          }
          if (i === (length - 1)) {
            setTimeout(e => {
              let insertIndex = this.pageData.bodyElements.indexOf(tempId)
              for (let ix = 0; ix < this.tempElementList.length; ix++) {
                this.createDuplicateImageChild(this.tempElementList[ix], fn => {
                  if (fn !== false) {
                    this.viewPortItems.splice(insertIndex + 1, 0, fn.id);
                    this.pageData.bodyElements.splice(insertIndex + 1, 0, fn.id);
                  }
                });
              }
              this.changeFlag = true;
              //this.generatePageAutoSaveInterval();
              this.generateAutoSave.emit()
              this.showLoader = false;
            }, 2000);
          }
        } else {
          this.showLoader = false;
        }


      }
    }
    event.target.value = null;
    // this.isLightbox = false;
    // this.leadMediaImageToggle = false;
    // this.leadMediaHomeImageToggle = false;
    this.inlineImageToggle = false;
  }

  createDuplicateImageChild(id, callback, type?) {
    this.restService.http_get(
      this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element')
      + '/' + id
    )
      .subscribe(result => {
        // let defaultImagecardData = $.extend(true, {}, result);
        // console.log(' result :: ');
        // console.log(result);
        let defaultImagecardData = Object.assign({}, result);
        defaultImagecardData['id'] = null;
        defaultImagecardData['parentElementId'] = id;
        defaultImagecardData['amazonAds'] = [
          {
            "key": "",
            "value": "",
            "isPresent": false
          }
        ];
      
        defaultImagecardData['amazonMeta'] = false;
        defaultImagecardData['amazonCheckedItem'] = false;
        defaultImagecardData['amazonTitle'] = '';
        defaultImagecardData['relatedStories'] = null;
        defaultImagecardData['relatedVideoStories'] = null;
        console.log("THIS IS THE TYPE ==>", type)
        if (type === 'sampleimage') {
          defaultImagecardData.image.sampleImage = true;
        }
        setTimeout(e => {
          //this.increasePendingCount();
          this.restService.http_post(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
            defaultImagecardData, result2 => {
              //this.decreasePendingCount(null);
              if (!result2.hasOwnProperty('error')) {
                callback(result2);
              } else {
                callback(false);
              }
            });
          this.restService.http_put(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), 'element', 'update_parent') + '/' + id,
            result, result2 => {
            });
        }, 50);
      },
        err => {
          // console.log(err);
          callback(false);
        });
  }


  addInlineImage() {
    this.inlineImageFlag = true;
    this.sharedService.overflowhidden();
  }

  disableInlineImage() {
    this.inlineImageFlag = false;
    this.inlineImageToggle = false;
    this.sharedService.overflowauto();
  }

  addMultipleInlineImages(ev) {
    this.disableInlineImage();
    let tempId;
    const element = ev[0];
    if (element.imgtype === 'wire') {
      this.saveCard(element, 'elements');
      if (ev.length > 1) {
        for (let i = 1; i < ev.length; i++) {
          if (ev[i].imgtype === 'wire') {
            this.saveCard(ev[i], 'elements');
          }
        }
      }
    } else {
      if (this.pageData.bodyElements == null || this.pageData.bodyElements.indexOf(element.id) < 0) {
        this.createDuplicateImageChild(element.id, fn => {
          if (fn !== false) {
            const arr = [];
            arr.push(fn);
            tempId = fn.id;
            this.decideTaskToPerformNew(arr, 0, e => {
              setTimeout(() => {
                this.checkIfLastIsPara(false);
                let insertIndex = this.pageData.bodyElements.indexOf(tempId)
                if (ev.length > 1) {
                  for (let i = 1; i < ev.length; i++) {
                    if (ev[i].imgtype === 'wire') {
                      for (let i = 1; i < ev.length; i++) {
                        if (ev[i].imgtype === 'wire') {
                          this.saveCard(ev[i], 'elements');
                        }
                      }
                    } else {
                      this.createDuplicateImageChild(ev[i].id, fn => {
                        if (fn !== false) {
                          this.viewPortItems.splice(insertIndex + 1, 0, fn.id);
                          this.pageData.bodyElements.splice(insertIndex + 1, 0, fn.id);
                        }
                      });
                    }
                  }
                }
              }, 250);
            });
          }
        });
      }
    }
  }


  saveCard(imagePath, model) {
    // console.log(imagePath);
    const defaultImagecardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
    defaultImagecardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    const fd = new FormData();
    fd.set('file', imagePath.id);
    //this.increasePendingCount();
    // console.log(imagePath);
    this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadByUrlEndPoint, fd).
      subscribe(res => {
        //this.decreasePendingCount(null);
        // console.log(res);
        if (defaultImagecardData && res && !res.hasOwnProperty('error')) {
          defaultImagecardData.id = null;
          defaultImagecardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
          defaultImagecardData.image.images['original'] = res['images']['original'];
          defaultImagecardData.image.caption = imagePath.data.caption ? imagePath.data.caption : '';
          defaultImagecardData.image.imageCredit = imagePath.data.credit ? imagePath.data.credit : '';
          defaultImagecardData.metadata.authors = imagePath.data.byLine ? [imagePath.data.byLine] : [];
          defaultImagecardData.metadata.agency = imagePath.data.agency ? imagePath.data.agency : '';
          //this.increasePendingCount();
          this.restService.http_post(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
            defaultImagecardData, result => {
              console.log('result -- > ', result);
              //this.decreasePendingCount(null);
              if (model === 'elements') {
                const arr = [];
                arr.push(result);
                this.decideTaskToPerformNew(arr, 0, e => {
                  setTimeout(() => {
                    this.startCroppingGallery(result.id);
                    this.checkIfLastIsPara(false);
                  }, 1000);
                });
              }
            });
        }
        return null;
      },
        err => {
          if (err.status == 404) {
            this.snotify.error(err.error.errorMessage, this.sharedService.getConfig(false))
          }
          this.showCropper = false;
        });
  }

  startCroppingGallery(id: any) {
    if (this.cropAllGallery) {
      let cropped = this.elReference['_results'][this.viewPortItems.indexOf(id)].startCropping();
      if (cropped == false) {
        this.imageCroppingQue.push(id);
        this.croppingInProgress = false;
        // this.triggerSequentialCropping();
      }
    }
  }

  addInlineImageEmit(ev) {
    this.disableInlineImage();
    if (ev.type === 'wire') {
      // console.log(ev);
      this.saveCard(ev, 'elements');
      this.disableInlineImage();
    } else {
      this.createDuplicateImageChild(ev.id, fn => {
        if (fn !== false) {
          const arr = [];
          arr.push(fn);
          this.decideTaskToPerformNew(arr, 0, e => {
            setTimeout(() => {
              this.checkIfLastIsPara(false);
            }, 250);
          });
          this.disableInlineImage();
        } else {
          // console.log('couldn\'nt create duplicate child');
        }
      });
    }
  }


  openEmbedPopup(model) {
    this.embedPopup = true;
    this.embedCode = '';
    this.embedSourceUrl = '';
    this.embedSubType = '';
    this.showLShapeBand = false;
    this.inlineImageToggle = false;
    this.inlineTableToggle = false;
  }

  showMessage(element) {
    if (this.lastindex && this.lastindex.id && this.lastindex.id === 'newElement') {
      this.focusedCard = null;
      this.lastindex = null;
      this.snotify.info('Data Saving in Progress. Please place cursor at the point of ' + element + ' insertion.',
        '', this.sharedService.getConfig(false));
    }
  }

  isButtonDisabled() {
    return (this.lastindex && this.lastindex.id && this.lastindex.id === 'newElement');
  }

  closeEmbedPopup() {
    this.embedPopup = false;
    this.embedCode = '';
    this.embedSourceUrl = '';
    this.embedSubType = '';
  }

  saveEmbed() {
    if (this.embedCode && this.embedCode !== null && this.embedCode.trim() !== '') {
      if (this.domainConfig && this.domainConfig['config']
        && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['autoEmbed'] === 'true') {
        this.sharedService.checkAndGetEmbed(this.embedCode, (embed) => {
          if (embed !== null) {
            this.embedCode = embed;
          }
          setTimeout(e => {
            this.addEmbed();
          }, 20);
        });
      } else {
        this.addEmbed();
      }
    } else {
      this.snotify.error('Enter a valid embed', '', this.sharedService.getConfig(false));
    }
  }

  addEmbed() {
    let checkProductFlag = false;
    const embedCard = JSON.parse(JSON.stringify(StaticDataService.defaultEmbedCardData));
    embedCard.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    const duration = this.sharedService.checkForMetadataDuration(this.embedCode);
    // console.log(this.embedCode, duration);
    if (duration !== false) {
      embedCard.metadata.videoMetadata = {};
      embedCard.metadata.videoMetadata.duration = duration;
    }
    embedCard.embed.body = this.sharedService.checkEmbed(this.embedCode);
    embedCard.jsonSourceUrl = this.embedSourceUrl.trim();
    embedCard.subType = this.embedSubType.trim();
    embedCard.reusable = false;
    embedCard.amazonMeta = false;
    embedCard.snapdealMeta = false;
    embedCard.cromaMeta = false;
    embedCard.lshapeBand = this.showLShapeBand;

    //this.increasePendingCount();
    this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      embedCard, result => {
        //this.decreasePendingCount(null);
        const arr = [];
        arr.push(result);
        this.decideTaskToPerformNew(arr, 0, e => {
          setTimeout(() => {
            this.checkIfLastIsPara(false);
            //this.checkForSourceUrlInEmbed(null);
          }, 500);
        });

      });

    this.embedPopup = false;
  }

  getEmbedPopupTitle() {
    if (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['autoEmbed'] === 'false') {
      return 'Add Embed code for the video, tweet, etc';
    } else {
      return 'Add Embed code/URL (youtube, dailymotion, & vimeo only) for the video, tweet, etc';
    }
  }

  showVideoGallery(destination,index?) {
    index||index===0 ? this.videoIndex = index : this.videoIndex = '';
    this.isLightboxVideo = true;
    this.isVideopopup = true;
    this.leadMediaVideoToggle = true;
    this.elementDestination = destination;
    this.inlineImageToggle = false;
    this.inlineTableToggle = false;
    this.enableListicleImageOption = false;
    this.sharedService.overflowhidden();
  }

  disableshowVideoGallery() {
    this.isLightboxVideo = false;
    this.isVideopopup = false;
    this.leadMediaVideoToggle = false;
    this.elementDestination = null;
    if (this.enableJW === 'true') {
      this.showJW = true;
      this.showYT = false;
    }
    else if (this.enableYT) {
      this.showJW = false;
      this.showYT = true;
    }
    this.sharedService.overflowauto();
  }


  getLeadMediaVideo(obj, autoEmbedded = false) {
    let paraid;
    let videoid;
    this.videoUrl = obj.standardEmbedCode != null || obj.standardEmbedCode !== undefined ? obj.standardEmbedCode : null;
    this.videoUrl = this.videoUrl.substring(this.videoUrl.indexOf('<iframe'), (this.videoUrl.indexOf('</div') > -1) ? this.videoUrl.indexOf('</div') : this.videoUrl.length);
    const fd = new FormData();
    this.videoLeadImage = (obj.images && obj.images.img_720) ? obj.images.img_720 : '';
    fd.set('file', this.videoLeadImage);
    this.http.post(this.config.get('product').imageUploadUrl
      + this.config.get('product').imageUploadByUrlEndPoint, fd).
      subscribe(res => {
        // this.cropperImageUrl.data = res['images']['original'];
        // this.cropperImageUrl.url = res['images']['original'];
      })
    let videoCard;
    let paragraphCard;
    if (!autoEmbedded) {
      videoCard = JSON.parse(JSON.stringify(StaticDataService.defaultVideoCardData));
      videoCard.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
      videoCard.title = obj.name;

      if (this.sharedService.isEmbedStripEnabled() && this.videoUrl.indexOf('cdn.jwplayer.com') > -1) {
        if (this.videoUrl.indexOf('src="') > -1) {
          const url = this.videoUrl.split('iframe src="')[1].split('"')[0];
          videoCard.video.embedUrl = url;
          videoCard.video.body = this.sharedService.checkEmbed(this.videoUrl);
          videoCard.video.uploadDate = obj.created_at;
          videoCard.video.description = obj.description;
          videoCard.video.thumbnailUrl = this.videoLeadImage;

        } else if (this.videoUrl.indexOf('src=\'') > -1) {
          const url = this.videoUrl.split('iframe src=\'')[1].split('\'')[0];
          videoCard.video.embedUrl = url;
          videoCard.video.body = this.sharedService.checkEmbed(this.videoUrl);
          videoCard.video.uploadDate = obj.created_at;
          videoCard.video.description = obj.description;
          videoCard.video.thumbnailUrl = this.videoLeadImage;

        }
      } else {
        if (this.videoUrl.indexOf('src="') > -1) {
          videoCard.video.embedUrl = this.videoUrl.split('src="')[1].split('"')[0];
          videoCard.video.body = this.videoUrl;
          videoCard.video.uploadDate = obj.created_at;
          videoCard.video.description = obj.description;
          videoCard.video.thumbnailUrl = this.videoLeadImage;

        } else if (this.videoUrl.indexOf('src=\'') > -1) {
          videoCard.video.embedUrl = this.videoUrl.split('src=\'')[1].split('\'')[0];
          videoCard.video.body = this.videoUrl;
          videoCard.video.uploadDate = obj.created_at;
          videoCard.video.description = obj.description;
          videoCard.video.thumbnailUrl = this.videoLeadImage;
        } else {
          this.snotify.error('Enter a valid embed', '', this.sharedService.getConfig(false));
          return false;
        }
      }
    } else {
      videoCard = JSON.parse(JSON.stringify(StaticDataService.defaultEmbedCardData));
      videoCard.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
      if (this.videoUrl.indexOf('src="') > -1) {
        const url = this.videoUrl.split('iframe src="')[1].split('"')[0];
        videoCard.embed.url = url;
        videoCard.embed.body = this.sharedService.checkEmbed(this.videoUrl);
      } else if (this.videoUrl.indexOf('src=\'') > -1) {
        const url = this.videoUrl.split('iframe src=\'')[1].split('\'')[0];
        videoCard.embed.url = url;
        videoCard.embed.body = this.sharedService.checkEmbed(this.videoUrl);
      }
    }
    videoCard.metadata.videoMetadata = {};
    videoCard.metadata.videoMetadata.duration = obj.duration;
    //this.increasePendingCount();
    console.log(videoCard);
    //creating new element for pragraph which store video title
    if (this.paraBeforeVideo) {
      paragraphCard = JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
      paragraphCard.domainId = videoCard.domainId;
      paragraphCard.paragraph.body = `<h2>Watch: ${obj.name}</h2>`
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
        paragraphCard, result => {
          //this.decreasePendingCount(null);
          if (this.elementDestination === 'elements') {
            paraid = result.id;
            this.decideTaskToPerformNew([result], 0, e => {
              // console.log('rsult',[result])   
              console.log('e=>', e)
              setTimeout(() => {
                this.checkIfLastIsPara(false);
              }, 250);
              if (!e) {
                this.restService.http_post(this.config.get('product').baseUrl
                  + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
                  videoCard, result => {
                    //this.decreasePendingCount(null);
                    if (this.elementDestination === 'elements') {
                      videoid = result.id;
                      let storyElements = this.pageData.bodyElements;
                      let index = storyElements.findIndex((v) => v == paraid)
                      storyElements.splice(index + 1, 0, videoid);
                      this.pageData.bodyElements = [...storyElements];
                      setTimeout(() => {
                        this.checkIfLastIsPara(false);
                      }, 250);
                      // });
                    }
                    this.disableshowVideoGallery();

                  });
              }
            });

          }

        });

    }
    else {
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
        videoCard, result => {
          //this.decreasePendingCount(null);
          if (this.elementDestination === 'elements') {
            this.decideTaskToPerformNew([result], 0, e => {
              setTimeout(() => {
                this.checkIfLastIsPara(false);
              }, 250);
            });
          } else if(this.elementDestination === 'listicleMedia'){
            this.listicleMediaVideo = obj;
            // this.disableshowVideoGallery();
              const videoCardData = JSON.parse(JSON.stringify(StaticDataService.defaultVideoCardData));
              videoCardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
              videoCardData.id = null;
              videoCardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
              videoCardData.video.body =this.listicleMediaVideo.standardEmbedCode;
              videoCardData.video.description =this.listicleMediaVideo.description;
              videoCardData.video.uploadDate =this.listicleMediaVideo.created_at;
              videoCardData.video.embedUrl = this.listicleMediaVideo.videoPath;
              videoCardData.metadata.videoMetadata = {};
              videoCardData.metadata.videoMetadata.duration = this.listicleMediaVideo.duration;
                this.restService.http_post(this.config.get('product').baseUrl
                + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
                videoCardData, result => {
                  // this.decreasePendingCount(null);
                  this.tempListicleData.get('listicleArray')['controls'][this.videoIndex].get('mediaId').setValue(result.id)
                })
              this.tempListicleData.get('listicleArray')['controls'][this.videoIndex].get('media').setValue({'video':videoCardData.video})
              this.tempListicleData.get('listicleArray')['controls'][this.videoIndex].get('mediaType').setValue('video')
        }
          this.disableshowVideoGallery();

        });

    }
  }

  isTableEnabled() {
    return (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['tableReusable'] === 'true');
  }

  createNewTable(model) {
    this.tablePopup = true;
    this.tableHTML = '';
    let eventCategory = 'Insert Table';
    let eventAction = sessionStorage.getItem(StaticDataService.tenantName);
    let eventLabel = '';
    let eventValue = null;;
  }

  openElementModal(ev) {
    if (ev === 'table') {
      this.tableReusablePopup = true; // for  story insert table | pick from library
    }
    this.sharedService.overflowhidden();
  }

  htmlToPlainTextExcludingAttributes(text) {
    if (typeof text === 'string') {
      return this.htmlSpecialCharToText(
        (text)
          .replace(new RegExp('style="[^"]*"', 'g'), '')
          .replace(new RegExp('style=\'[^\']*\'', 'g'), '')
          .replace(new RegExp('class="[^"]*"', 'g'), '')
          .replace(new RegExp('class=\'[^\']*\'', 'g'), '')
          .replace(new RegExp('href="[^"]*"', 'g'), '')
          .replace(new RegExp('href=\'[^\']*\'', 'g'), '')
          .replace(new RegExp('src="[^"]*"', 'g'), '')
          .replace(new RegExp('src=\'[^\']*\'', 'g'), '')
          .replace(new RegExp('<p><br></p>', 'g'), '')
        // string.replace("<p><br></p>", "");


      );
    } else {
      return text;
    }
  }

  closeTable() {
    this.tablePopup = false;
    this.tableHTML = '';
  }

  changeTable() {
    const tableElement = JSON.parse(JSON.stringify(StaticDataService.defaultTableCardData));
    tableElement.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    tableElement.paragraph.body = ('' + this.tableHTML).replace('<figure class="table">', '').replace('</figure>', '');
    //this.increasePendingCount();
    this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      tableElement, result => {
        //this.decreasePendingCount(null);
        const arr = [];
        arr.push(result);
        this.decideTaskToPerformNew(arr, 0, e => {
          setTimeout(() => {
            this.checkIfLastIsPara(false);
          }, 500);
        });

        setTimeout(e => {
          this.closeTable();
        }, 300);
      });

  }

  closeElementModal(ev) {
    this.tableReusablePopup = false;
    this.sharedService.overflowauto();
  }

  addElementToStory(ev) {
    this.closeElementModal(null);
    // this.closeEmbedModal();
    if (this.pageData.bodyElements == null || this.pageData.bodyElements.indexOf(ev) === -1) {
      this.decideTaskToPerformNew([{ id: ev }], 0, e => { });
    } else {
      this.snotify.warning('This element already exists in story', '', this.sharedService.getConfig(false));
    }
  }


  openFaqPopup() {
    this.resetFaqSection();
    this.showFaqPopup = true;
    this.inlineImageToggle = false;
    this.inlineTableToggle = false;
  }
  openLabelPopup() {
    this.showLabelPopup = true;
    this.inlineImageToggle = false;
  }
  openSeparatorPopup() {
    this.showSeparatorPopup = true;
    this.inlineImageToggle = false;
  }

  resetFaqSection() {
    this.tempFaqData = this.formBuilder.group({
      heading: new FormControl('', [Validators.required]),
      faqs: this.formBuilder.array([this.createFaqItem()])
    });
  }

  createFaqItem(): FormGroup {
    return this.formBuilder.group({
      key: new FormControl('', [Validators.required]),
      value: new FormControl('', [Validators.required])
    });
  }

  closeFaqPopup() {
    this.resetFaqSection();
    this.showFaqPopup = false;
  }
  closeLabelPopup() {
    this.showLabelPopup = false;
    this.label ='';
  }
  closeSepartorPopup() {
    this.showSeparatorPopup = false;
    this.separator='';
  }

  addFaq() {
    this.faqs = this.tempFaqData.get('faqs') as FormArray;
    this.faqs.push(this.createFaqItem());

  }

  deleteFaq(idx) {
    this.faqs = this.tempFaqData.get('faqs') as FormArray;
    this.faqs.removeAt(idx);
  }

  saveFaqs() {
    if (this.tempFaqData.valid) {
      let faqData = this.tempFaqData.getRawValue();
      const card = JSON.parse(JSON.stringify(StaticDataService.defaultFaqCardData));
      card.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
      card['faqs'] = faqData.faqs;
      card['faqSectionHeading'] = faqData.heading;
      //this.increasePendingCount();
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
        card, result => {
          //this.decreasePendingCount(null);
          this.decideTaskToPerformNew([result], 0, e => {
            setTimeout(() => {
              this.checkIfLastIsPara(false);
            }, 500);
          });
          this.closeFaqPopup();
          //this.storyData.elements.push(result.id);
          //this.viewPortItems.push(result.id);
        });
    } else {
      this.tempFaqData.get('heading').markAsTouched();
      (this.tempFaqData.get('faqs') as FormArray).controls.forEach(e => {
        Object.keys((e as FormGroup).controls).forEach(e1 => {
          (e as FormGroup).controls[e1].markAsTouched();
        });
      });
      this.snotify.error('Enter required fields', '', this.sharedService.getConfig(false));
    }

  }

  saveLabel(){
    if (this.label != '') {
      const card = JSON.parse(JSON.stringify(StaticDataService.defaultLabelCardData));
      card.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
      card.label = this.label;
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
        card, result => {
          this.decideTaskToPerformNew([result], 0, e => {
            setTimeout(() => {
              this.checkIfLastIsPara(false);
            }, 500);
          });
          this.label = '';
          this.closeLabelPopup();
        });
    } else {
      this.snotify.error('Enter required fields', '', this.sharedService.getConfig(false));
    }

  }

  saveSeparator(){
    if (this.separator != '') {
      const card = JSON.parse(JSON.stringify(StaticDataService.defaultSeparatorCardData));
      card.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
      card.separator = this.separator;
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
        card, result => {
          this.decideTaskToPerformNew([result], 0, e => {
            setTimeout(() => {
              this.checkIfLastIsPara(false);
            }, 500);
          });
          this.separator = '';
          this.closeSepartorPopup();
        });
    } else {
      this.snotify.error('Enter required fields', '', this.sharedService.getConfig(false));
    }

  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    console.log("charCode",charCode)
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
         return false;
      }
      return true;
  }

  htmlSpecialCharToText(text) {
    const translate_re = /&(nbsp|amp|quot|lt|gt);/g;
    const translate = {
      'nbsp': ' ',
      'amp': '&',
      'quot': '\'',
      'lt': '<',
      'gt': '>'
    };
    return (text.replace(translate_re,
      (match, entity) => {
        return translate[entity];
      })
    );
  }

  htmlToPlainTextExcludingPara(text) {
    if (typeof text === 'string') {
      return this.htmlSpecialCharToText(text);
    } else {
      return text;
    }
  }

  ckchanges(ev, label, model) {
    if (label === 'ready') {
      this.tableEditor = ev;
      const clipboardPlugin = ev.plugins.get('Clipboard');
      const editingView = ev.editing.view;
      editingView.document.on('clipboardInput', (evt, data) => {
        if (ev.isReadOnly) {
          return;
        }
        const dataTransfer = data.dataTransfer;
        const plaintext = dataTransfer.getData('text/plain');
        const htmltext = dataTransfer.getData('text/html');
        //const text = this.htmlToPlainTextExcludingPara(plaintext);
        let text = this.htmlToPlainTextExcludingPara(plaintext);
        if (model == 'table') {
          const div = document.createElement('div');
          div.innerHTML = this.htmlToPlainTextExcludingAttributes(htmltext.replace(StaticDataService.regexForComments, ''));
          text = div.innerHTML;
        }
        const content = clipboardPlugin._htmlDataProcessor.toView(text);
        clipboardPlugin.fire('inputTransformation', { content, dataTransfer });
        editingView.scrollToTheSelection();
        evt.stop();
      });
    }
    if(label === 'change'){
      this.checkingHyperlinkValid(this.tableEditor,label,this.tableHTML);
    }
  }

  checkingHyperlinkValid(editor,type,data) {
    if(editor && editor.model) {
      const doc = editor.model.document;
      const selection = doc.selection;
      const range = selection.getFirstRange();
      let selectedWord;
      for (const item of range.getItems()) {
        selectedWord = item.data;
    }
      let docStr = (JSON.stringify(doc));
      if(JSON.parse(docStr)['differ']['_cachedChanges'][0]['attributeKey'] === 'linkHref'){
        let hrefUrl = this.sharedService.extractHrefUrl(editor);
          if(hrefUrl !== undefined && hrefUrl !== null) {
            let allLink =  this.sharedService.findInvalidLinkWord(editor);
            let matchLinkObj = allLink.filter(e =>e.href===hrefUrl)
            const validLink = this.checkUrlValidate(hrefUrl,data,type,editor);
            if(validLink){
              this.restService.http_get(this.config.get('product').utilUrl + '/api/cms/validate/link/?url='+hrefUrl)
              .subscribe((response) => {
              if(response.statusCode === 200){
              } else {
              setTimeout(e4 => {
                if(editor) {
                  this.getremoveInvalidLink(data,matchLinkObj[0].linkText,type,editor)
                }
              }, 1000); 
              this.snotify.error('Link is invalid', '', this.sharedService.getConfig(false));
            }
          },error=>{
            setTimeout(e4 => {
              if(editor) {
                this.getremoveInvalidLink(data,matchLinkObj[0].linkText,type,editor)
              }
            }, 1000); 
            this.snotify.error('Link is invalid', '', this.sharedService.getConfig(false));
            })
          
          }
          }
      }
    }
     else {
      return true;
    }
  }

  checkUrlValidate(url,data,type,editor) {
    var urlValid = /[a-z0-9-]*\.?[a-z0-9-]+\.[a-z0-9-]+\.?[a-z0-9-]+(\/[^<>]*)?$/;
    let allLink =  this.sharedService.findInvalidLinkWord(editor);
    let matchLinkObj = allLink.filter(e =>e.href===url)
    if(urlValid.test(url) === false) {
       this.snotify.info('Please enter valid URL', '', this.sharedService.getConfig(false));
       setTimeout(e4 => {
         if(editor) {
           this.getremoveInvalidLink(data,matchLinkObj[0].linkText,type,editor)
         }
       }, 1000);
     } else if(!url.startsWith('https')) {
       this.snotify.error('Link is invalid,link should be start with https.Please enter valid link.', '', this.sharedService.getConfig(false));
       setTimeout(e4 => {
         if(editor) {
           this.getremoveInvalidLink(data,matchLinkObj[0].linkText,type,editor)
         }
       }, 1000);    
     }
     return urlValid.test(url) && url.startsWith('https') ;
  }

  getremoveInvalidLink(cardData,word,type,editor){
    let paraBody=cardData;
      if(!!word && !!cardData){
        let replaceThis = '<a[^>]*>'+word+'<\/a>'
        let regexReplace = new RegExp(`${replaceThis}`)
        let l = regexReplace.exec(paraBody);
        if(!!l && l.length>0){
          paraBody = paraBody.replace(regexReplace, word);
          cardData= paraBody;
          editor ? editor.setData(cardData):'';
        }
      }
  }

  setStoryHeight() {
    const intViewportHeight = window.innerHeight - 140;
    const styles = {
      'min-height': + intViewportHeight + 'px'
    };
    return styles;
  }

  insertListingElement(event){
    this.resetListicleSection();
    this.showListiclePopup = true;
  }

  resetListicleSection() {
    this.tempListicleData = this.formBuilder.group({
      heading: new FormControl('', [Validators.required]),
      listicleBulletType: new FormControl('number', [Validators.required]),
      listicleArray: this.formBuilder.array([ this.createListicleItem() ])
    });
  }

  createListicleItem(): FormGroup {
    return this.formBuilder.group({
      key: new FormControl('', [Validators.required]),
      value: new FormControl('', [Validators.required]),
      url: new FormControl(null),
      media: new FormControl(null),
      mediaType: new FormControl(''),
      mediaId: new FormControl('')
    });
  }

  deleteListicle(idx){
    this.listicleArray = this.tempListicleData.get('listicleArray') as FormArray;
    this.listicleArray.removeAt(idx);
  }

  addListicleImage(index,el: HTMLElement) {
    this.videoIndex = index;
    this.enableListicleImageOption = true
    setTimeout(() => {
      el.scrollIntoView();
    }, 500);
  }

  showListcleEmbed(index) {
    this.enableListicleImageOption = false;
    this.videoIndex = index;
    this.listicleEmbedCode = '';
    this.showEmbedForListcleElement = true;
    this.showListiclePopup = false;
  }

  closeListicleEmbedPopup() {
    this.showEmbedForListcleElement = false;
    this.showListiclePopup = true;
  }

  // showVideoGallery(destination, index?) {
  //   index||index===0 ? this.videoIndex = index : this.videoIndex = '';
  //   this.isLightboxVideo = true;
  //   this.isVideopopup = true;
  //   this.leadMediaVideoToggle = true;
  //   this.elementDestination = destination;
  //   this.enableListicleImageOption = false;
  //   this.enableFAQImageOption = false;
  //   this.sharedService.overflowhidden();
  //   if(destination=='elements'){
  //     let eventCategory='Insert Video';
  //     let eventAction=sessionStorage.getItem(StaticDataService.tenantName);
  //     let eventLabel='';
  //     let eventValue=null;;
  //     this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue);
  //   }
  // }

  saveEmbedData(){
    this.showEmbedForListcleElement = false;
    this.showListiclePopup = true;
    this.sharedService.runEmbedProcessor(this.listicleEmbedCode, this.embedElement);
    this.tempListicleData.get('listicleArray')['controls'][this.videoIndex].get('media').setValue({'embedCode': this.listicleEmbedCode});
    this.tempListicleData.get('listicleArray')['controls'][this.videoIndex].get('mediaType').setValue('embed');
    const embedCardData = JSON.parse(JSON.stringify(StaticDataService.defaultEmbedCardData));
    embedCardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    embedCardData.id = null;
    embedCardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
    embedCardData.embed.body = this.listicleEmbedCode;
    // this.SingleselectedFile = null;
    // this.increasePendingCount();
    this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      embedCardData, res => {
        // this.decreasePendingCount(null);
        this.tempListicleData.get('listicleArray')['controls'][this.videoIndex].get('mediaId').setValue(res.id);
        this.videoIndex = ''
       });
  }

  deleteListicleMedia(index) {
    this.tempListicleData.get('listicleArray')['controls'][index].patchValue({
      'media': null,
      'mediaId':'',
      'mediaType':''
    });
  }

  onFileChangeSingle(event, model) {
    let file_name = <File>event.target.files[0].name;
    const reader = new FileReader();
    this.imageLoaderShow = true;
    this.enableListicleImageOption = false;
    if (model === 'listicleUploadImage') {
      // console.log('file uplaod called');
      const fd = new FormData();
      this.SingleselectedFile = <File>event.target.files[0];
      // console.log(this.SingleselectedFile);
      this.imageUploadInProgress = true;
      if (event.target.files && event.target.files.length > 0) {
        if ((typeof event.target.files[0]) === 'object') {
          // console.log(event.target.files[0]);
          if ((this.SingleselectedFile.size / 1000000) <= 11) {
            const a = reader.readAsDataURL(event.target.files[0]);
            reader.onload = (e: any) => {
              this.sharedService.checkImageForAMP(reader, flag => {
                if (flag) {
                  if ( model === 'listicleUploadImage') {
                    this.imageLoaded = false;
                    this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'listicleUploadImage');
                  } 
                } else {
                  this.sharedService.showAMPConfirmPopup(() => { // yes
                    if ( model === 'listicleUploadImage') {
                      this.imageLoaded = false;
                      this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'listicleUploadImage');
                    } 
                  },
                    () => { // no
                      this.SingleselectedFile = null;
                      this.imageUploadInProgress = false;
                    }
                  );
                }
              });
            };
          } else {
            this.SingleselectedFile = null;
            this.imageUploadInProgress = false;
            this.snotify.error('Image size exceeds 12 MB', '', this.sharedService.getConfig(false));
          }
        }
      }
      event.target.value = null;
      // this.isLightbox = false;
      // this.leadMediaImageToggle = false;
      // this.leadMediaHomeImageToggle = false;
      this.inlineImageToggle = false;
    }
  }

  uplaodImageAndOpenCropper(imageFile, base64, type) {
    this.snotify.info('Uploading', '', this.sharedService.getConfig(false));
    let allowLowQuality = false;
    if(type === 'listicleUploadImage' ){
      allowLowQuality = true
    }
    this.sharedService.uploadImage(imageFile,allowLowQuality).
      subscribe(res => {
        this.cropperImageUrl.data = base64;
        this.cropperImageUrl.url = res['images']['original'];
        this.thumborCompressed = res['thumborCompressed'];
        if(type === 'listicleUploadImage') {
          this.enableListicleImageOption = false;
          this.addListicleImageMedia(res['images']['original'],0)
        }
      },
        error => {
          // this.SingleselectedFile = null;
          // this.SingleselectedGifFile = null;
          this.showLoader = false;
          if(error.error.errorMessage && error.error.errorMessage.indexOf('low')>-1) {
            this.showDefaultImageSelector = true;
            this.snotify.error('Upload Failed', '', this.sharedService.getConfig(false));
          } 
          else{
          this.snotify.error(error.error.errorMessage, '', this.sharedService.getConfig(false));
        }
          this.uploadType = type;
          this.imageLoaderShow = false;
          this.imageLoaded = true;
          this.imageUploadInProgress = false;
        });
  }

  addListicleImageMedia(result,parentElementId) {
    const ImageCardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
    ImageCardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    ImageCardData.id = null;
    ImageCardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
    ImageCardData.image.images = {};
    ImageCardData.image.images['original'] = result;
    ImageCardData.parentElementId = parentElementId
    ImageCardData.image['infographicImage'] = true;
    ImageCardData['removeLowQualityRestriction'] = true;
    this.SingleselectedFile = null;
    // this.increasePendingCount();
    this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      ImageCardData, image => {
        let obj = { image: image.image}        
        // this.decreasePendingCount(null);
        this.tempListicleData.get('listicleArray')['controls'][this.videoIndex].get('mediaId').setValue(image.id);
        this.tempListicleData.get('listicleArray')['controls'][this.videoIndex].get('media').setValue(obj);
        this.videoIndex = ''
        this.imageLoaderShow = false;
      });
    this.tempListicleData.get('listicleArray')['controls'][this.videoIndex].get('mediaType').setValue('image');
    this.SingleselectedFile = null;
  }

  addListicleInlineImage() {
    this.imageLoaderShow = true;
    this.enableListicleImageOption = false;
    this.listicleInlineImageFlag = true;
    this.imageLoaded = false;
  }

  disabledListicleImageMedia() {
    this.imageLoaderShow = false;
    this.disableStepsInlineImage();
  }

  disableStepsInlineImage() {
    this.listicleInlineImageFlag = false;
    //this.FAQInlineImageFlag = false;
    this.sharedService.overflowauto();
  }

  addStepsInlineImageEmit(ev, model) {
    this.disableStepsInlineImage();
    if (ev.type === 'wire') {
      console.log(ev);
      this.saveCard(ev, model);
    } else {
      this.restService.http_get(
        this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element')
        + '/' + ev.id
      )
        .subscribe(result => {
          console.log('addStepsInlineImageEmit, result :: ');
          console.log(result);
          if(model === 'listicleUploadImage') {
            this.addListicleImageMedia(result.image.images.original,result.id);
          }
          const elementImageURL = this.sharedService.getImageOnPriority(result['image']['images'], 'original');
          const imageUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage + elementImageURL;
          this.sharedService.createObjectFromImageUrl(imageUrl, (data, reader) => {
            if (data !== false) {
              console.log("image data : 1 :: ", data);
              this.openCropper(false, data, model);
            } else {
              this.snotify.error('Image path does not exist.', '', this.sharedService.getConfig(false));
            }
          });
        },
          err => {
            this.snotify.error('Image could not be added', '', this.sharedService.getConfig(false));
          });
    }
  }

  openCropper(isCropForLeadMedia, data, model) {
    this.cropperImageUrl.data = data.data;
    this.cropperImageUrl.url = data.url;
  }

  onImageLoad() {
    this.imageLoaded = true;
  }

  addListicle(el: HTMLElement) {
    this.listicleArray = this.tempListicleData.get('listicleArray') as FormArray;
    this.listicleArray.push(this.createListicleItem());
      setTimeout(() => {
        el.scrollIntoView();
      }, 500);
  }

  closeListiclePopup() {
    this.resetListicleSection();
    this.showListiclePopup = false;
    this.enableListicleImageOption = false;
  }

  saveListicleElement() {
    const listicleCard = JSON.parse(JSON.stringify(StaticDataService.defaultListicleElementCardData));
    listicleCard.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    listicleCard.listicleHeadline = this.tempListicleData.get('heading').value;
    listicleCard.listicleBulletType = this.tempListicleData.get('listicleBulletType').value;
    listicleCard.listicleArray = this.tempListicleData.get('listicleArray').value;
      //this.increasePendingCount();
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
        listicleCard, result => {
          //this.decreasePendingCount(null);
          this.decideTaskToPerformNew([result], 0, e => {
            setTimeout(() => {
              this.checkIfLastIsPara(false);
            }, 500);
          });
        });
      this.closeListiclePopup();
  }

  openRelatedStoryModal(type, ev) {
    this.storyList =[];
    // let eventCategory='Insert ' + type + ' Story';
    // let eventAction=sessionStorage.getItem(StaticDataService.tenantName);
    // let eventLabel='';
    // let eventValue=null;
    //this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue);
    if (ev === 'multiple') {
        this.relatedStoryType='';
        this.relatedStoryMultipleSelectFlag = true;
        if(type === 'Also Read') {
          this.relatedStoryType='alsoread';
          this.showAlsoReadStoryPopup = true;
        }
        this.sharedService.overflowhidden();
    } else {
      this.relatedStoryType='';
        this.relatedStoryMultipleSelectFlag = false;
        if(type === 'Also Read') {
          this.relatedStoryType='alsoread';
          this.showAlsoReadStoryPopup = true;
        }
        this.sharedService.overflowhidden();
    }
  }

  closeRelatedStoryModal(ev) {
    this.showAlsoReadStoryPopup = false;
    this.sharedService.overflowauto();
  }

  getAlsoReadId(ev)
  {
    let alsoReadStoryIdList = [ev];
    this.getAlsoReadIds(alsoReadStoryIdList);
  }

  getAlsoReadIds(ev) {
    console.log('in Save case')
    const card = JSON.parse(JSON.stringify(StaticDataService.defaultAlsoReadCardData));
    card.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    card['alsoReadStories'] = {};
    card['alsoReadStoriesUrl'] = {};
    card['alsoReadStoryIdList'] = ev;
    //this.increasePendingCount();
    this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      card, result => {
        //this.decreasePendingCount(null);
        this.closeRelatedStoryModal(null);
        const arr = [];
        arr.push(result);
        this.decideTaskToPerformNew(arr, 0, e => {
          setTimeout(() => {
            this.checkIfLastIsPara(false);
          }, 250);
        });
      });
  }

}
